(function () {
    var parseRequirement = function (requirement) {
        if (isNaN(+requirement))
            return parseFloat($(requirement).val());
        else
            return +requirement;
    };

    // global options
    $.extend(window.Parsley.options, {
        errorsWrapper: '<span></span>',
        errorTemplate: '<span class="message validation"></span>',
        trigger: 'change keyup'
    });

    // Greater than validator
    window.Parsley.addValidator('gt', {
        validateString: function (value, requirement) {
            return parseFloat(value) > parseRequirement(requirement);
        },
        requirementType: 'string',
    });
  
    // Greater than or equal to validator
    window.Parsley.addValidator('gte', {
        validateString: function (value, requirement) {
            return parseFloat(value) >= parseRequirement(requirement);
        },
        requirementType: 'string',
    });
  
    // Less than validator
    window.Parsley.addValidator('lt', {
        validateString: function (value, requirement) {
            return parseFloat(value) < parseRequirement(requirement);
        },
        requirementType: 'string',
    });
    
    // Less than or equal to validator
    window.Parsley.addValidator('lte', {
        validateString: function (value, requirement) {
            return parseFloat(value) <= parseRequirement(requirement);
        },
        requirementType: 'string',
    });
    
    // not equal to than validator
    window.Parsley.addValidator('notequalto', {
        validateString: function (value, requirement) {
            return parseFloat(value) !== ($(requirement).length ? parseRequirement($(requirement).val()) : requirement);
        },
        requirementType: 'string',
    });

    // less than or equal to than validator
    window.Parsley.addValidator('lessthanorequalto', {
        validateString: function(value, requirement) {
            return parseFloat(value) <= ($(requirement).length ? parseRequirement($(requirement).val()) : requirement);
        },
        requirementType: 'string'
    });

    // file mime type validator
    window.Parsley.addValidator('filemimetype', {
        validateString: function (value, requirement, parsleyInstance) {
            var file = parsleyInstance.$element[0].files,
                allowedMimeTypes = requirement.replace(/\s/g, '').split(',');
            
            if (file.length == 0) {
                return true;
            }

            return allowedMimeTypes.indexOf(file[0].type) !== -1;
        },
        requirementType: 'string'
    });


    // file size validator
    window.Parsley.addValidator('filesize', {
        validateString: function (value, requirement, parsleyInstance) {
            var file = parsleyInstance.$element[0].files,
                maxBytes = parseFloat(requirement, 10) * 1048576;

            if (file.length == 0) {
                return true;
            }

            return file.length === 1 && file[0].size <= maxBytes;
        },
        requirementType: 'string'
    });

    // hide server side validation when parsley re-validates
	window.Parsley.on('field:validated', function(field) {
        // hide server side validation message
        // can either be a sibling of parent (.field-wrap) or a direct sibling of the field
        field.$element.parent().siblings('.message.required, .message.error').hide();
        field.$element.siblings('.message.required, .message.error').hide();
    });

})();
